<template>
    <v-overlay :dark="false" class="overlay">
        <a v-if="$store.state.application.providerCode === 'lamotte'" href="https://youtu.be/dynx_RKKOjw" target="_blank">
            <v-img class="mb-5 rounded" src="@/assets/bandeau_lamotte.jpg" />
        </a>

        <LoginCard :style="{ minWidth: $vuetify.breakpoint.xs ? '0px' : '600px' }" />
    </v-overlay>
</template>

<script>
import LoginCard from '../components/login/PartnerLoginCard.vue';

export default {
    name: 'Login',

    components: {
        LoginCard
    }
};
</script>

<style lang="scss" scoped>
.overlay::v-deep .v-overlay__content {
    max-width: 100%;
}
</style>